/* Novelys NFC — comportements.
   Charge par l'en-tete ET par chaque section : sans le verrou ci-dessous il
   s'executerait plusieurs fois et doublerait chaque ecouteur.
   Les apparitions au defilement appartiennent a nv-reveal.js, pas a ce fichier. */
(function () {
  'use strict';
  if (window.__nvCoreReady) return;
  window.__nvCoreReady = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Ce theme defile dans .page-wrapper, pas sur window. */
  var box;
  function scroller() {
    if (box === undefined) box = document.querySelector('.page-wrapper') || null;
    if (box && box.scrollHeight > box.clientHeight + 1) return box;
    return null;
  }
  function scrollTop() {
    var s = scroller();
    if (s) return s.scrollTop;
    return window.pageYOffset || document.documentElement.scrollTop || 0;
  }
  function onAnyScroll(fn) {
    document.addEventListener('scroll', fn, { passive: true, capture: true });
    window.addEventListener('resize', fn, { passive: true });
  }

  /* ---------- Filet d'apparition ----------
     nv-reveal.js possede les apparitions. Si ce fichier n'a pas ete charge, on
     affiche tout d'un coup : mieux vaut perdre l'animation que laisser le prix
     d'un produit a opacity:0. */
  function revealFallback() {
    if (window.__nvRevealReady) return;
    document.querySelectorAll('[data-nv-in]:not(.is-in)').forEach(function (el) {
      el.classList.add('is-in');
    });
  }

  /* ---------- Decalage automatique ---------- */
  function stagger() {
    document.querySelectorAll('[data-nv-stagger]').forEach(function (group) {
      if (group.dataset.nvStag === '1') return;
      group.dataset.nvStag = '1';
      var step = parseFloat(group.getAttribute('data-nv-stagger')) || 70;
      var rank = 0;
      [].forEach.call(group.children, function (child) {
        if (!child.hasAttribute('data-nv-in')) return;
        child.style.setProperty('--d', (rank * step).toFixed(0) + 'ms');
        rank++;
      });
    });
  }

  /* ---------- L'epaisseur de la plaque ----------
     La tranche n'est pas dessinee : elle est extrudee. On empile NV_SLICES
     copies de la silhouette entre le dos et la face, toutes avec le meme
     border-radius. Comme elles sont espacees d'un demi-pixel, on ne voit pas
     les couches ; on voit un bord plein qui suit exactement l'arrondi. */
  var NV_SLICES = 18;
  function extrude(plaque) {
    if (plaque.querySelector('.nv-plaque__slice')) return;
    var frag = document.createDocumentFragment();
    for (var i = 0; i < NV_SLICES; i++) {
      var s = document.createElement('i');
      s.className = 'nv-plaque__slice';
      s.setAttribute('aria-hidden', 'true');
      s.style.setProperty('--z', 'calc(var(--t) * ' + (-0.5 + i / (NV_SLICES - 1)).toFixed(4) + ')');
      frag.appendChild(s);
    }
    plaque.insertBefore(frag, plaque.firstChild);
  }

  /* ---------- La plaque : rotation sur les deux axes ----------

     POURQUOI LE BASCULEMENT VERTICAL EST BORNE A 65 DEGRES.
     Amjad a photographie le defaut le 26 aout 2026 : passe un certain angle, la
     plaque se decompose en lamelles blanches avec une diagonale au milieu.
     Ce n'est pas un bug qu'on corrige, c'est la limite du procede. L'epaisseur
     est faite de 18 copies de la silhouette empilees en profondeur ; vue **par
     la tranche**, il n'y a plus de surface a montrer, seulement 18 plans qui se
     chevauchent. Aucun reglage ne rattrape ca : il faudrait un vrai moteur 3D.
     On borne donc l'inclinaison a +/- 65 degres, ou l'objet reste toujours
     solide. L'axe vertical (Y), lui, tourne librement sur 360 : la plaque y est
     symetrique et l'extrusion se lit correctement a tous les angles.

     Le basculement est refuse au doigt : sur mobile, un glisser vertical doit
     faire defiler la page. A la souris et au clavier, les deux axes repondent.

     `data-nv-speed="0"` coupe la rotation automatique. Dans ce cas il n'y a plus
     d'animation en boucle, donc plus besoin du bouton pause (WCAG 2.2.2) : la
     plaque attend qu'on la prenne. */
  var NV_TILT_MAX = 65;
  function turntable() {
    [].slice.call(document.querySelectorAll('[data-nv-turn]')).forEach(function (stage) {
      if (stage.dataset.nvReady === '1') return;
      var plaque = stage.querySelector('[data-nv-plaque]');
      if (!plaque) return;
      stage.dataset.nvReady = '1';

      extrude(plaque);

      var floor = stage.querySelector('.nv-stage3d__floor');
      var btn = stage.querySelector('[data-nv-spin]');
      var label = btn ? btn.querySelector('[data-nv-spin-label]') : null;

      var speed = parseFloat(stage.getAttribute('data-nv-speed') || '17');
      var perPx = parseFloat(stage.getAttribute('data-nv-scroll') || '0.13');
      var perDrag = parseFloat(stage.getAttribute('data-nv-drag') || '0.5');
      var angle = parseFloat(stage.getAttribute('data-nv-from') || '0');
      var tilt = parseFloat(stage.getAttribute('data-nv-tilt') || '-10');

      function borne(v) { return Math.max(-NV_TILT_MAX, Math.min(NV_TILT_MAX, v)); }
      tilt = borne(tilt);

      var spinning = speed > 0 && !reduced.matches;
      var visible = true;
      var raf = 0;
      var last = 0;
      var lastScroll = scrollTop();

      function apply() {
        plaque.style.setProperty('--ry', angle.toFixed(2) + 'deg');
        plaque.style.setProperty('--rx', tilt.toFixed(2) + 'deg');
        plaque.style.transform =
          'rotateX(' + tilt.toFixed(2) + 'deg) rotateY(' + angle.toFixed(2) + 'deg)';
        if (floor) {
          var c = Math.abs(Math.cos(angle * Math.PI / 180));
          var v = Math.abs(Math.cos(tilt * Math.PI / 180));
          floor.style.setProperty('--shadow-x', (0.34 + 0.66 * c).toFixed(3));
          floor.style.opacity = (0.25 + 0.75 * v).toFixed(3);
        }
      }
      function frame(t) {
        raf = 0;
        if (!spinning || !visible || document.hidden) { last = 0; return; }
        if (last) angle = (angle + (t - last) / 1000 * speed) % 360;
        last = t;
        apply();
        raf = window.requestAnimationFrame(frame);
      }
      function start() {
        if (!spinning || !visible || document.hidden || raf) return;
        last = 0;
        raf = window.requestAnimationFrame(frame);
      }
      function stop() {
        if (raf) window.cancelAnimationFrame(raf);
        raf = 0;
        last = 0;
      }
      function setSpin(v) {
        spinning = v && speed > 0;
        if (btn) {
          btn.setAttribute('aria-pressed', spinning ? 'true' : 'false');
          if (label) label.textContent = spinning ? 'Arrêter la rotation' : 'Faire tourner l’objet';
        }
        if (spinning) start(); else stop();
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          if (visible) start(); else stop();
        }, { threshold: 0 }).observe(stage);
      }
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else start();
      });
      onAnyScroll(function () {
        var s = scrollTop();
        var d = s - lastScroll;
        lastScroll = s;
        if (!visible || !d || !perPx) return;
        angle = (angle + d * perPx) % 360;
        if (!spinning) apply();
      });
      /* Le bouton n'existe que la ou la rotation automatique existe. */
      if (btn && speed > 0) {
        btn.hidden = false;
        btn.addEventListener('click', function () { setSpin(!spinning); });
      } else if (btn) {
        btn.remove();
      }

      /* ---------- Prise en main ---------- */
      var dragId = null, dragX = 0, dragY = 0, fromA = 0, fromT = 0, dragTouch = false;

      stage.classList.add('is-grabbable');
      stage.setAttribute('tabindex', '0');
      stage.setAttribute('role', 'img');
      stage.setAttribute('aria-label',
        'Plaque NFC en volume. Faites-la glisser, ou utilisez les flèches du clavier, pour la tourner.');

      stage.addEventListener('pointerdown', function (e) {
        if (dragId !== null) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (e.target.closest('button, a')) return;
        dragId = e.pointerId;
        dragTouch = e.pointerType === 'touch';
        dragX = e.clientX;
        dragY = e.clientY;
        fromA = angle;
        fromT = tilt;
        stop();
        stage.classList.add('is-grabbing');
        try { stage.setPointerCapture(dragId); } catch (err) {}
      });
      stage.addEventListener('pointermove', function (e) {
        if (e.pointerId !== dragId) return;
        e.preventDefault();
        angle = (fromA + (e.clientX - dragX) * perDrag) % 360;
        if (!dragTouch) tilt = borne(fromT - (e.clientY - dragY) * perDrag);
        apply();
      });
      function endDrag(e) {
        if (dragId === null || (e && e.pointerId !== dragId)) return;
        try { stage.releasePointerCapture(dragId); } catch (err) {}
        dragId = null;
        stage.classList.remove('is-grabbing');
        start();
      }
      stage.addEventListener('pointerup', endDrag);
      stage.addEventListener('pointercancel', endDrag);

      stage.addEventListener('keydown', function (e) {
        var dy = e.key === 'ArrowRight' ? 12 : e.key === 'ArrowLeft' ? -12 : 0;
        var dx = e.key === 'ArrowUp' ? 12 : e.key === 'ArrowDown' ? -12 : 0;
        if (!dy && !dx) return;
        e.preventDefault();
        if (spinning) setSpin(false);
        if (dy) angle = (angle + dy) % 360;
        if (dx) tilt = borne(tilt + dx);
        apply();
      });

      apply();
      setSpin(spinning);
    });
  }

  /* ---------- En-tete ---------- */
  function header() {
    var head = document.querySelector('[data-nv-head]');
    if (!head || head.dataset.nvReady === '1') return;
    head.dataset.nvReady = '1';

    function measure() {
      var h = head.offsetHeight;
      if (h > 0) document.documentElement.style.setProperty('--nv-head-h', h + 'px');
    }
    measure();
    window.addEventListener('resize', measure, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure).catch(function () {});

    var stuck = function () { head.classList.toggle('is-stuck', scrollTop() > 8); };
    onAnyScroll(stuck);
    stuck();

    var burger = head.querySelector('[data-nv-burger]');
    if (!burger) return;
    var setOpen = function (v) {
      head.setAttribute('data-open', v ? 'true' : 'false');
      burger.setAttribute('aria-expanded', v ? 'true' : 'false');
    };
    burger.addEventListener('click', function (e) {
      e.stopPropagation();
      setOpen(head.getAttribute('data-open') !== 'true');
    });
    head.querySelectorAll('.nv-head__panel a').forEach(function (a) {
      a.addEventListener('click', function () { setOpen(false); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
    document.addEventListener('click', function (e) {
      if (head.getAttribute('data-open') === 'true' && !head.contains(e.target)) setOpen(false);
    });
  }

  /* ---------- Selecteur de quantite ---------- */
  function packs() {
    document.querySelectorAll('[data-nv-packs]').forEach(function (root) {
      if (root.dataset.nvReady === '1') return;
      var inputs = [].slice.call(root.querySelectorAll('input[name="id"]'));
      if (!inputs.length) return;
      root.dataset.nvReady = '1';

      var name = root.querySelector('[data-nv-sel-name]');
      var price = root.querySelector('[data-nv-sel-price]');
      var unit = root.querySelector('[data-nv-sel-unit]');
      var ship = root.querySelector('[data-nv-sel-ship]');
      var btn = root.querySelector('[data-nv-sel-btn]');
      var barPrice = document.querySelector('[data-nv-bar-price]');
      var barName = document.querySelector('[data-nv-bar-name]');
      var first = true;

      function sync() {
        var on = inputs.filter(function (i) { return i.checked; })[0];
        if (!on) return;
        var d = on.dataset;
        if (name) name.textContent = d.name || '';
        if (price) price.textContent = d.price || '';
        if (unit) unit.textContent = d.unit || '';
        if (ship) ship.hidden = d.freeship !== 'true';
        if (barPrice) barPrice.textContent = d.price || '';
        if (barName) barName.textContent = d.name || '';
        if (btn) {
          var ok = d.available === 'true';
          btn.disabled = !ok;
          btn.textContent = ok ? 'Ajouter au panier — ' + d.price : 'Indisponible';
        }
        var wrap = price ? price.closest('.nv-buy__price') : null;
        if (wrap && !first && !reduced.matches) {
          wrap.classList.remove('is-set');
          void wrap.offsetWidth;
          wrap.classList.add('is-set');
        }
        first = false;
      }
      inputs.forEach(function (i) { i.addEventListener('change', sync); });
      sync();
    });
  }

  /* ---------- Barre d'achat mobile ---------- */
  function buybar() {
    var bar = document.querySelector('[data-nv-buybar]');
    if (!bar || bar.dataset.nvReady === '1') return;
    var anchor = document.querySelector('[data-nv-sel-btn]');
    if (!anchor || !('IntersectionObserver' in window)) return;
    bar.dataset.nvReady = '1';

    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var passe = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-on', passe);
      bar.setAttribute('aria-hidden', passe ? 'false' : 'true');
    }, { threshold: 0 }).observe(anchor);
  }

  /* ---------- Galerie a onglets ----------
     Ne sert plus a la fiche produit depuis la galerie verticale du 26 aout 2026,
     mais reste pour toute section qui l'utiliserait. */
  function gallery() {
    document.querySelectorAll('[data-nv-gallery]').forEach(function (root) {
      if (root.dataset.nvReady === '1') return;
      var slides = [].slice.call(root.querySelectorAll('[data-nv-slide]'));
      var tabs = [].slice.call(root.querySelectorAll('[data-nv-thumb]'));
      if (slides.length < 2) return;
      root.dataset.nvReady = '1';

      function show(n) {
        slides.forEach(function (s, i) {
          s.classList.toggle('is-on', i === n);
          s.setAttribute('aria-hidden', i === n ? 'false' : 'true');
          var v = s.querySelector('video');
          if (v && i !== n) v.pause();
        });
        tabs.forEach(function (t, i) { t.setAttribute('aria-current', i === n ? 'true' : 'false'); });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { show(i); });
        t.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          tabs[n].focus();
          show(n);
        });
      });
      show(0);
    });
  }

  function boot() {
    header();
    stagger();
    revealFallback();
    turntable();
    packs();
    buybar();
    gallery();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
